import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import { TAddToMyVendors, TGetVendorListRequest, TVendorList } from './types'
import { ResponseWithPagination } from 'constants/types'

const fetcher = new Fetcher({})

export const getVendorRepositoryRequest = async (data) =>
  fetcher.request<TGetVendorListRequest, ResponseWithPagination<TVendorList>>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.VENDORS}${API_DICTIONARY.REPOSITORY}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const upgradeVendor = async (uuid: string) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.VENDORS}${uuid}/${API_DICTIONARY.PROMOTE}`,
    method: HTTP_METHODS.POST
  })

export const addToMyVendors = async (data: TAddToMyVendors) =>
  fetcher.request<TAddToMyVendors, unknown>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.VENDORS}${API_DICTIONARY.MY_VENDORS}`,
    method: HTTP_METHODS.POST,
    data
  })
